import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class IntraOperativeMedicationsgiven extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Drug: "",
      Dosage: "",
      Route: "",
      Time: "",
      Givenby: "",

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"optheatre/operativeorders/intra/optheatre/medicationsgiven ",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/intra/op/positioningcatheter";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const { Drug, Dosage, Route, Time, Givenby } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    IntraOperative Entry
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Drug
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Drug}
                      name="Drug"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Dosage
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Dosage}
                      name="Dosage"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Route
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Route}
                      name="Route"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Time
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Time}
                      name="Time"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Givenby
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Givenby}
                      name="Givenby"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}
export default IntraOperativeMedicationsgiven;
